import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject, Subject, catchError, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StorageService } from './storage.service';

@Injectable({
    providedIn: 'root',
})
export class PermissionsService {
    private userPermissions: string[] = [];
    private userPermissions$: ReplaySubject<any> = new ReplaySubject<any>();
    private isUserAdmin: boolean = false;
    private authenticatedUserId!: number;

    private authBasePath = environment.interop.authCore.basePath;
    private getUserPermissionsUrl =
        this.authBasePath +
        environment.interop.authCore.platform.getUserPermissionsAuthLib;

    constructor(
        private http: HttpClient,
        private storageService: StorageService
    ) { }

    private fetchUserPermissions(clientId: number, moduleId: number) {
        return this.http
            .get(this.getUserPermissionsUrl + clientId + '/' + moduleId)
            .pipe(
                // tap((data) => console.log(data)),
                map(
                    (response: any) =>
                        (Object.values(response.data)[0] as any).permissions
                )
            );
    }

    storeUserPermissions() {
        return this.fetchUserPermissions(
            environment.interop.clientId,
            environment.interop.moduleId
        ).subscribe({
            next: (data: any) => {
                this.userPermissions = data;
                this.userPermissions$.next(true);
            },
            error: (err: any) => {
                console.log(err);
            },
        });
    }

    getUserPermissions() {
        return this.userPermissions;
    }

    getUserPermissions$() {
        return this.userPermissions$;
    }

    checkUserAdmin(): any {
        var self = this;
        const userObj = self.storageService.getObject(environment.config.userKey);
        userObj
            .then((val) => {
                this.isUserAdmin = val.user_type === 'admin' ? true : false;
                this.authenticatedUserId = val.id_user;
                // this.isUserAdmin = val.user_type_id == 2 ? true : false;
            })
            .catch((err) => {
                console.log(err, 'error on storage read');
            });
    }

    hasPermission(targetPermission: string): boolean {
        // if (this.isUserAdmin) {
        //     return true;
        // }
        return this.userPermissions.some((permission) =>
            permission === targetPermission
        );
    }

    isAuthenticatedUser(userId: number): boolean {
        return this.authenticatedUserId === userId;
    }
}
